export interface Metadata {
  maximumListItemImageWidth: number
  maximumListItemImageHeight: number
  maximumListItemCount: number
  maximumListSectionCount: number
  maximumListImageRowItemImageWidth: number
  maximumListImageRowItemImageHeight: number
  maximumListGridImagesCount: number
  displayScale: number
}
